import { render, staticRenderFns } from "./HomeDiscounts.vue?vue&type=template&id=21d5f7c9&scoped=true&"
import script from "./HomeDiscounts.vue?vue&type=script&lang=js&"
export * from "./HomeDiscounts.vue?vue&type=script&lang=js&"
import style0 from "./HomeDiscounts.vue?vue&type=style&index=0&id=21d5f7c9&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d5f7c9",
  null
  
)

export default component.exports